<template>
  <section id="featured_podium" v-if="podium">
    <h2 class="title_section"><b-icon icon="square-fill" class="puce"></b-icon>Podium</h2>
    <div class="container_flex_podium" v-if="$store.state.classement_type === 'Homme' || $store.state.classement_type === 'Femme'">
      <CarteCoureurSm v-if="podium[0]" :coureur="podium[0]"></CarteCoureurSm>
      <CarteCoureurSm v-if="podium[1]" :coureur="podium[1]"></CarteCoureurSm>
      <CarteCoureurSm v-if="podium[2]" :coureur="podium[2]"></CarteCoureurSm>
    </div>
    <div class="container_flex_podium" v-else>
      <div class="coureur" v-if="podium[0]">
        <div class="infos">
          <p class="nom">{{ podium[0].name }}</p>
          <p class="points">{{ podium[0].points }}pts</p>
          <p class="nom">1er</p>
        </div>
      </div>
      <div class="coureur" v-if="podium[1]">
        <div class="infos">
          <p class="nom">{{ podium[1].name }}</p>
          <p class="points">{{ podium[1].points }}pts</p>
          <p class="nom">2ème</p>
        </div>
      </div>
      <div class="coureur" v-if="podium[2]">
        <div class="infos">
          <p class="nom">{{ podium[2].name }}</p>
          <p class="points">{{ podium[2].points }}pts</p>
          <p class="nom">3ème</p>
        </div>
      </div>
    </div>
    <p v-if="podium.length === 0" style="text-align: left">Il n'y a pas encore de participant à ce challenge</p>
  </section>
</template>

<script>
import CarteCoureurSm from "../components/CarteCoureurSm.vue";
export default {
  components: { CarteCoureurSm },
  data() {
    return {
      podium: [],
    };
  },
  watch: {
    "$store.state.classement": function () {
      this.buildPodium();
    },
  },
  methods: {
    buildPodium() {
      this.podium = [];
      let finisher = this.$store.state.classement.filter((item) => item.nb_participations >= 8);
      if (finisher.length > 3) {
        this.podium = finisher.slice(0, 3);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container_flex_podium {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
}
</style>
